/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/qrCodeCard.scss';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {QrCodeProduct} from '../../util/interfaces';
import {onCopy} from '../../util/utils';
import {BolmateButton, BolmateImageFallback, BolmateTooltip} from '../controls';
import CopyIcon from '../misc/copyIcon';
import {useInView} from '../misc/useInView';

interface Props {
    product: QrCodeProduct;
    downloading: boolean;
    onClickDownload: VoidFunction;
    onVisible: VoidFunction;
}

export default function QrCodeCard(props: Props) {
    const {product, downloading, onClickDownload, onVisible} = props;
    const {t} = useTranslation();
    const cardRef = useRef<HTMLDivElement>(null);
    useInView(cardRef, onVisible, {resetKey: product});

    return (
        <div className='qr-code-card' ref={cardRef}>
            <div className='card-image'>
                <BolmateImageFallback src={product.image_url ?? null} imageClassName='product-image' />
            </div>
            <div className='card-cell product-cell'>
                <label className='cell-main'>{product.title ?? '-'}</label>
                <div className='with-copy-action'>
                    <label className='cell-sub'>EAN: {product.ean}</label>
                    <CopyIcon onClick={onCopy(product.ean, true)} className='copy-action' autoReset />
                </div>
            </div>
            <div className='card-cell scans-cell'>
                <BolmateTooltip text={t('qrCodes.scansTooltip', 'Het aantal keren dat deze QR-code is gescand')}>
                    <label className='cell-main'>{product.qr_scan_counts}</label>
                </BolmateTooltip>
                <label className='cell-sub'>{t('qrCodes.scansLabel', 'Scans')}</label>
            </div>
            <div className='card-action'>
                <BolmateTooltip text={t('qrCodes.download.tooltip', 'Download QR-code')}>
                    <div className='download-btn-wrap'>
                        <BolmateButton
                            onClick={onClickDownload}
                            label={<AwesomeIcon name='qrcode' />}
                            loading={downloading}
                            tertiary
                            shape='square'
                            size='small'
                            className='download-btn'
                        />
                    </div>
                </BolmateTooltip>
            </div>
        </div>
    );
}
